import Vue from 'vue'

const baseSize = 16
// 设置 rem 函数
function setRem () {
  // 当前页面宽度相对于 1440宽的缩放比例，可根据自己需要修改。
//   var scale = document.documentElement.clientWidth / 375
//   if(document.documentElement.clientWidth < 375){
//     scale = 1;
//   }

//   Vue.prototype.$scale = scale

//   document.documentElement.style.fontSize = baseSize * Math.min(scale, 4) + 'px'
}

setRem()

window.onresize = function () {
  setRem()
}